import {InputProps} from "antd";
import DatePicker from "react-datepicker";
import {range} from "underscore";
import {CalendarOutlined} from '@ant-design/icons';
import {useState} from "react";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment/moment";

export interface CPDatePickerProps extends InputProps {
    value?: any;
    onChange?: (date: any) => void;
    className?: string;
}

const getYear = (date: Date) => {
    //if date null use now
    if (!date) date = new Date();
    return date.getFullYear();
}
const getMonth = (date: Date) => {
    //if date null use now
    if (!date) date = new Date();
    return date.getMonth()
}

const CPDatePicker = ({ value, onChange, ...props }: CPDatePickerProps) => {
    const [startDate, setStartDate] = useState(value ? new Date(value) : null);
    const years = range(1900, getYear(new Date()) + 1, 1);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    return (
        <div className="cp-datepicker-wrapper">
            <DatePicker
                {...{...props, value: undefined}}
                renderCustomHeader={({
                                         date,
                                         changeYear,
                                         changeMonth,
                                         decreaseMonth,
                                         increaseMonth,
                                         prevMonthButtonDisabled,
                                         nextMonthButtonDisabled,
                                     }) => (
                    <div
                        style={{
                            margin: 10,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="react-datepicker-header-btn">
                            {"<"}
                        </button>
                        <select
                            value={getYear(date)}
                            onChange={({target: {value}}) => changeYear(value)}
                            className="react-datepicker-header-select"
                        >
                            {years.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                        <select
                            value={months[getMonth(date)]}
                            onChange={({target: {value}}) =>
                                changeMonth(months.indexOf(value))
                            }
                            className="react-datepicker-header-select"
                        >
                            {months.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>

                        <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="react-datepicker-header-btn">
                            {">"}
                        </button>
                    </div>
                )}
                placeholderText="Select date"
                popperPlacement="bottom"
                selected={startDate}
                onChange={(date) => {
                        setStartDate(date)
                        if(onChange) {
                            const newDate = date ? moment(date) : null;
                            onChange(newDate)
                        }
                    }
                }
            />
            <CalendarOutlined className="cp-datepicker-icon iconGrey icon16" />
        </div>
    );
}

export default CPDatePicker;